/**
 * Olfactive Hero [New] — reveal on load / in view
 */
(function () {
  var SECTION_TYPE = 'olfactive-hero-new';

  function enhance(root) {
    if (!root || root._vgOhReady) return;
    root._vgOhReady = true;
    var el = root.querySelector('[data-oh-reveal]');
    if (!el) return;

    if (typeof IntersectionObserver === 'undefined') {
      el.classList.add('is-in');
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            el.classList.add('is-in');
            io.disconnect();
          }
        });
      },
      { threshold: 0.2 }
    );
    io.observe(el);
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="' + SECTION_TYPE + '"]').forEach(enhance);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (event) {
    var root =
      (event.target.querySelector &&
        event.target.querySelector('[data-section-type="' + SECTION_TYPE + '"]')) ||
      null;
    if (!root && event.target.getAttribute && event.target.getAttribute('data-section-type') === SECTION_TYPE) {
      root = event.target;
    }
    if (root) {
      root._vgOhReady = false;
      enhance(root);
    }
  });
})();
